import React from 'react';
import { Container, Typography, Grid, Paper, Button, Box, Chip } from '@mui/material';
import { AccessTime, ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const StudentDeadlines: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
            <Button startIcon={<ArrowBack />} onClick={() => navigate('/student-dashboard')} sx={{ mb: 3 }}>
                Back to Dashboard
            </Button>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 4 }}>
                <AccessTime sx={{ fontSize: 40, color: '#ff7675' }} />
                <Typography variant="h4" fontWeight="bold">Critical Objectives (Deadlines)</Typography>
            </Box>

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mt: 2 }}>Today</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Paper sx={{ p: 3, borderRadius: 4, borderLeft: '6px solid #ff7675', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                            <Typography variant="h6" fontWeight="bold">Physics Lab Report</Typography>
                            <Typography variant="body2" color="error" fontWeight="bold">Due Today, 23:59</Typography>
                            <Typography variant="caption" color="text.secondary">Physics • Module 4</Typography>
                        </Box>
                        <Button variant="contained" color="error">Submit Now</Button>
                    </Paper>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mt: 2 }}>Tomorrow</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Paper sx={{ p: 3, borderRadius: 4, borderLeft: '6px solid #fdcb6e', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                            <Typography variant="h6" fontWeight="bold">History Essay Draft</Typography>
                            <Typography variant="body2" color="text.secondary" fontWeight="bold">Due Tomorrow, 14:00</Typography>
                            <Typography variant="caption" color="text.secondary">World History • Week 5</Typography>
                        </Box>
                        <Button variant="outlined" color="warning">Upload Draft</Button>
                    </Paper>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mt: 2 }}>Upcoming Week</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Paper sx={{ p: 3, borderRadius: 4, borderLeft: '6px solid #00d2d3', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box>
                            <Typography variant="h6" fontWeight="bold">Math Mid-Term Quiz</Typography>
                            <Typography variant="body2" color="text.secondary" fontWeight="bold">Due Friday, 10:00 AM</Typography>
                            <Typography variant="caption" color="text.secondary">Algebra II</Typography>
                        </Box>
                        <Chip label="Scheduled" color="info" variant="outlined" />
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
};

export default StudentDeadlines;
